(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-request-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const form = document.querySelector('[data-quote-form]');
    if (!form) return;

    const steps = Array.from(form.querySelectorAll('[data-step]'));
    const progressBar = form.querySelector('[data-progress-bar]');
    let current = 0;

    function showStep(index) {
      steps.forEach(function (s, i) {
        s.hidden = i !== index;
      });
      if (progressBar) {
        progressBar.style.width = ((index + 1) / steps.length * 100) + '%';
      }
      current = index;
      window.scrollTo({ top: form.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' });
    }

    form.querySelectorAll('[data-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const step = btn.closest('[data-step]');
        const required = step.querySelectorAll('[required]');
        let valid = true;
        required.forEach(function (el) {
          if (!el.checkValidity()) { el.reportValidity(); valid = false; }
        });
        if (!valid) return;
        if (current < steps.length - 1) showStep(current + 1);
      });
    });

    form.querySelectorAll('[data-back]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (current > 0) showStep(current - 1);
      });
    });

    // Assemble body field before submit
    const htmlForm = document.getElementById('lf-quote-form');
    if (htmlForm) {
      htmlForm.addEventListener('submit', function () {
        const bodyField = document.getElementById('lf-quote-body');
        if (!bodyField) return;

        const projectType = (htmlForm.querySelector('[name="contact[project_type]"]:checked') || {}).value || '—';
        const materials = Array.from(htmlForm.querySelectorAll('[name="contact[materials][]"]:checked')).map(function (el) { return el.value; }).join(', ') || '—';
        const area = htmlForm.querySelector('[name="contact[area_m2]"]')?.value || '—';
        const notes = htmlForm.querySelector('[name="contact[notes]"]')?.value || '—';

        bodyField.value = [
          'Project type: ' + projectType,
          'Materials: ' + materials,
          'Area (m²): ' + area,
          'Notes: ' + notes
        ].join('\n');
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
